import graphqlFetch from '@helpers/api/graphql-fetch';
import { generateUrlWithQueryParameter, REMOVE_FALSY } from '@helpers/url';
import { gql } from 'graphql-request';

import { collectionsGql, TCollections } from './collections';

import { AssembledPhotosData, assembledPhotosGql } from './assembledPhotos';
import { productFractionedGql, TFractionedPrice } from './fractioned';
import { getServerlessAllSectionByGroupData } from './sections/group';
import { tooltipContentGql, TTooltipConfig } from './tooltips';

const VALID_STATUS = [200];

const productGql = gql`
 query ProductPageConfigQuery { 
   productPageConfig {
    ${collectionsGql}
    ${productFractionedGql}
    ${tooltipContentGql}
    ${assembledPhotosGql}
  }
}
`;

export type TProductData = {
  productPageConfig: {
    productPageCollection: TCollections[];
    configPriceFractioned: TFractionedPrice[];
    configTooltipContent: TTooltipConfig[];
  } & AssembledPhotosData;
  productSectionsGroups: string[];
};

type TProductPagedataProps = {
  preview?: boolean;
  sections?: boolean;
};

async function getProductPageData({
  preview = false,
  sections = false,
}: TProductPagedataProps): Promise<TProductData> {
  const { productPageConfig = null } = await graphqlFetch(productGql, {
    preview,
  });

  const productSectionsGroups = sections
    ? await getServerlessAllSectionByGroupData({ preview })
    : [];

  return { productPageConfig, productSectionsGroups };
}

export async function getServerlessProductData({
  preview = false,
  sections = false,
}: TProductPagedataProps): Promise<any> {
  try {
    const url = generateUrlWithQueryParameter(
      `${process.env.NEXT_PUBLIC_HTTP_DOMAIN}/api/datocms/common-data/product`,
      {
        preview,
        sections,
      },
      REMOVE_FALSY
    );

    const response = await fetch(url);

    if (!VALID_STATUS.includes(response.status)) {
      throw new Error(`Invalid response status ${response.status}`);
    }

    return await response.json();
  } catch {
    return {
      productPageConfig: {
        productPageCollection: [],
        configPriceFractioned: [],
        configTooltipContent: [],
        assembledProductImagesTitle: '',
        assembledProductImagesCount: 0,
      },
      productSectionsGroups: [],
    };
  }
}

export default getProductPageData;
